export default function MCBoQTable({ items = [] }) {
  return (
    <div className="overflow-x-auto rounded-lg border border-gray-200">
      <table className="min-w-full text-sm">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-3 py-2 text-left">Capítulo</th>
            <th className="px-3 py-2 text-left">Material</th>
            <th className="px-3 py-2 text-left">Unidad</th>
            <th className="px-3 py-2 text-right">Cantidad final</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item, idx) => (
            <tr key={idx} className="border-t">
              <td className="px-3 py-2">{item.chapter}</td>
              <td className="px-3 py-2">{item.material}</td>
              <td className="px-3 py-2">{item.unit}</td>
              <td className="px-3 py-2 text-right">{item.quantity}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
